import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//import { ClientSearchComponent } from 'src/app/client-search/client-search.component';
import { SalariedEditorComponent } from 'src/app/client-search/salaried-editor/salaried-editor.component';
import { SassaEditorComponent } from 'src/app/client-search/sassa-editor/sassa-editor.component';
// import { BranchEmployersModule } from "src/app/features/branch-employers/branch-employers.module";
import {
  BasicEmployersSearchComponent,
} from 'src/app/features/branch-employers/basic-employer-form/basic-employer-form.component';
import {
  MdbButtonModule, MdbDatepickerModule, MdbDropdownModule, MdbRadioModule, MdbSelectModule,
} from 'src/lib/mdb5-adapted/public-api';

import { QuoteStoreService } from '../core/rest-services/quote-store.service';
import { BranchEmployerService } from '../core/services/branch-employer.service';
//import { ToastrService } from 'ngx-toastr';
import { UserService } from '../core/services/lmsuser.service';
import { LoanReasonCodesService } from '../modules/loan-reason-codes/loan-reason-codes.service';
import { AnnouncementBannerComponent } from '../shared/announcement-banner/announcement-banner.component';
import { LMSSelectOptionDirective } from '../shared/directives/lms-selectOption.directive';
import { SwitchdataComponent } from './switchdata/switchdata.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdbDatepickerModule,
    MdbSelectModule,
    MdbRadioModule,
    MdbButtonModule,
    //BranchEmployersModule,
    BasicEmployersSearchComponent,
    SassaEditorComponent,
    SalariedEditorComponent,
    SwitchdataComponent,
    AnnouncementBannerComponent,
   // ClientSearchComponent,
    LMSSelectOptionDirective,
    MdbDropdownModule
  ],
  providers: [
    DatePipe,
    BranchEmployerService,
    //ToastrService,
    UserService,
    LoanReasonCodesService,
    QuoteStoreService
  ]
})
export class ClientSearchModule { }
